import { render, staticRenderFns } from "./SourcesEdit.vue?vue&type=template&id=218f125a&scoped=true"
import script from "./SourcesEdit.vue?vue&type=script&lang=js"
export * from "./SourcesEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f125a",
  null
  
)

export default component.exports